const createMenuItemType = (name) => `MENU_ITEM__${name
    .split(' ')
    .join('_')
    .toUpperCase()}`;

const Types = {
    Home: createMenuItemType('Home'),
    Messages: createMenuItemType('Messages'),
    Advices: createMenuItemType('Advices'),
    Creator: createMenuItemType('Creator'),
    Earnings: createMenuItemType('Earnings'),
    Settings: createMenuItemType('Settings'),
    Form: createMenuItemType('Form'),
    ConfirmApplication: createMenuItemType('ConfirmApplication'),
    DenyApplication: createMenuItemType('DenyApplication'),
    Logout: createMenuItemType('Logout'),
    PageNotFound: createMenuItemType('PageNotFound'),
    ServerError: createMenuItemType('ServerError'),
    AuthErrorPage: createMenuItemType('AuthErrorPage'),
    NotAllowed: createMenuItemType('NotAllowed'),
    Archive: createMenuItemType('Archive'),
    Pracuj: createMenuItemType('Pracuj'),
    TheProtocol: createMenuItemType('TheProtocol')
};

export default Types;
